const Style = {

  helper: 'p-4 mb-4 rounded-panel border border-solid border-sg-line bg-sg-blue-05',
  icon: 'float-left mr-3',
  link: 'no-underline hover:underline'

}

export default Style;